import React from 'react';
import { InlineNotification } from 'carbon-components-react';
import StripePaymentCardSkeleton from './StripePaymentCardSkeleton';
import PricingSummarySkeleton, {
  PricingSummarySkeletonLineItem
} from './PricingSummarySkeleton';

interface PaymentScreenLayoutSkeletonProps {
  bannerMessage: string;
  lineItems: PricingSummarySkeletonLineItem[];
  totalLabel?: string;
}

const PaymentScreenLayoutSkeleton: React.FC<PaymentScreenLayoutSkeletonProps> = ({
  bannerMessage,
  lineItems,
  totalLabel = 'Total'
}) => {
  return (
    <div>
      <div className="payment-screen-layout__section payment-screen-layout__notification">
        <InlineNotification
          kind="info"
          title=""
          subtitle={bannerMessage}
          lowContrast
          hideCloseButton
        />
      </div>

      <div className="payment-screen-layout__section">
        <StripePaymentCardSkeleton />
      </div>

      <div className="payment-screen-layout__section">
        <div className="payment-screen-layout__summary-header">
          Invoice summary
        </div>
        <PricingSummarySkeleton
          lineItems={lineItems}
          totalLabel={totalLabel}
          showHeader
          variant="payment"
        />
      </div>

      <div className="payment-screen-layout__footer-note">
        Receipts and invoices are issued by Stripe. Disputes, refunds and
        payment queries should be directed to Stripe.
      </div>
    </div>
  );
};

export default PaymentScreenLayoutSkeleton;
